import { DirectionType } from './types'

export const getOriginByDirection = (
	direction: DirectionType,
	invert?: boolean
) =>
	(invert
		? {
				top: 'bottom center',
				left: 'center right',
				bottom: 'top center',
				right: 'center left',
				center: 'center center',
				'top-left': 'bottom right',
				'top-right': 'bottom left',
				'bottom-left': 'top right',
				'bottom-right': 'top left',
		  }
		: {
				top: 'top center',
				left: 'center left',
				bottom: 'bottom center',
				right: 'center right',
				center: 'center center',
				'top-left': 'top left',
				'top-right': 'top right',
				'bottom-left': 'bottom left',
				'bottom-right': 'bottom right',
		  })[direction] || 'center-center'
